// TODO: NonEmptyString newtype; otherwise the compiler loses that NonEmpty info
// and you'd still have to check length again.
// perhaps the definition already in newtype-ts?
export const isNonEmptyString = (s) => typeof s === 'string' && s.length > 0;
//# sourceMappingURL=util.js.map